module.exports = __WEBPACK_EXTERNAL_MODULE_36__;


//////////////////
// WEBPACK FOOTER
// external {"root":"angularDraggableDroppable","commonjs":"angular-draggable-droppable","commonjs2":"angular-draggable-droppable","amd":"angular-draggable-droppable"}
// module id = 36
// module chunks = 0